import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import { listTracks } from './src/api';
import { ChartsPage } from "./src/pages/chartPage";

import './css/main.scss';

const MainComponent = () => {
    const [chartsData, updateChartData] = useState([]);
    const [isLoading, setisLoading] = useState(true);
    const [loadingText, setLoadingText] = useState('LOADING...');

    useEffect(() => {
        listTracks()
            .then(res => {
                if (typeof res.data === 'object') {
                    updateChartData(res.data);
                    setisLoading(false);
                } else {
                    setLoadingText('SERVER ERROR :(');
                }
            }).catch(() => {
                updateChartData([]);
                setLoadingText('SERVER ERROR :(');
            });
    }, [])

    return <>
        {isLoading && <div className='loading'><div className='text-effect glitch' data-text={loadingText}>{loadingText}</div></div>}
        {!isLoading && <ChartsPage chartEntries={chartsData} />}
    </>
}

let App = document.getElementById("root");

ReactDOM.render(<MainComponent />, App);
